import { render, staticRenderFns } from "./DetailModalEdit.vue?vue&type=template&id=ef90b27c&scoped=true"
import script from "./DetailModalEdit.vue?vue&type=script&lang=js"
export * from "./DetailModalEdit.vue?vue&type=script&lang=js"
import style0 from "./DetailModalEdit.vue?vue&type=style&index=0&id=ef90b27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef90b27c",
  null
  
)

export default component.exports